import React from 'react';

const GatewayList = ({ gateways, onEdit, onDelete }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      {gateways.map((gateway) => (
        <div
          key={gateway.id}
          className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-smooth"
        >
          {/* Header */}
          <div className="flex items-start justify-between mb-4">
            <div className="flex-1">
              <h3 className="text-lg font-bold text-gray-900">{gateway.name}</h3>
              <p className="text-sm text-gray-500 mt-1">@{gateway.username}</p>
              {gateway.gatewayId && (
                <p className="text-xs text-indigo-600 mt-1 font-mono">ID: {gateway.gatewayId}</p>
              )}
              {gateway.midNumber && (
                <p className="text-xs text-emerald-600 mt-1 font-mono">MID: {gateway.midNumber}</p>
              )}
            </div>
            <span className={`px-2 py-1 text-xs font-medium rounded-full ${
              gateway.isActive 
                ? 'bg-green-100 text-green-800' 
                : 'bg-gray-100 text-gray-800'
            }`}>
              {gateway.isActive ? 'Active' : 'Inactive'}
            </span>
          </div>

          {/* Details */}
          <div className="mb-4 space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-600">Created:</span>
              <span className="text-gray-900">{formatDate(gateway.createdAt)}</span>
            </div>
            {gateway.updatedAt !== gateway.createdAt && (
              <div className="flex justify-between">
                <span className="text-gray-600">Updated:</span>
                <span className="text-gray-900">{formatDate(gateway.updatedAt)}</span>
              </div>
            )}
          </div>

          {/* Actions */}
          <div className="flex gap-2 pt-4 border-t border-gray-200">
            <button
              onClick={() => onEdit(gateway)}
              className="flex-1 px-4 py-2 text-sm font-medium text-primary-600 border border-primary-600 rounded-lg hover:bg-primary-50 transition-smooth"
            >
              Edit
            </button>
            <button
              onClick={() => onDelete(gateway.id)}
              className="flex-1 px-4 py-2 text-sm font-medium text-red-600 border border-red-600 rounded-lg hover:bg-red-50 transition-smooth"
            >
              Delete
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default GatewayList;
